module.exports = __webpack_public_path__ + "static/media/white_cross.6b57763c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/white_cross.png
// module id = 1913
// module chunks = 0